import { Frame, FrameAnchor } from '@studiometa/ui';
import PageTransition from './PageTransition.js';

/**
 * Frame étendu pour utiliser PageTransition (GSAP) à la place de FrameTarget (CSS transitionend).
 */
export default class MainFrame extends Frame {
  static config = {
    ...Frame.config,
    name: 'Frame',
    refs: ['overlay', 'scrim'],
    components: {
      ...Frame.config.components,
      FrameTarget: PageTransition,
      FrameAnchor,
    },
  };

  /**
   * @param {URL} url
   * @param {RequestInit} requestInit
   * @param {string} content
   * @returns {Promise<void>}
   */
  async content(url, requestInit, content) {
    const doc = this.domParser.parseFromString(content, 'text/html');
    const newBodyClass = doc.body.getAttribute('class');

    if (newBodyClass !== null) {
      document.body.setAttribute('class', newBodyClass);
    }

    return super.content(url, requestInit, content);
  }
}
